import { ManagerBase } from '@core/ManagerBase';
import type { IUIManager } from '@core/interfaces';

/** UI koordinasyonu — Phase 3+ implementasyon */
export class UIManager extends ManagerBase implements IUIManager {
  protected onInitialize(): void {
    // Phase 3
  }

  protected onShutdown(): void {
    // Phase 3
  }
}
